// extracted by mini-css-extract-plugin
export default {"menuBlock":"sF-z","title":"tF-z","nav":"uF-z","flexCell":"vF-z","facetLink":"wF-z"};